module.exports = __webpack_public_path__ + "img/office_pathway.8ab4caff.jpg";